<template>
	<div class="chart_window">
		<div class="chart_container" ref="messageBox">
			<!-- 历史消息 -->
			<div ref="historyBox" v-if="historyRecord.length > 0">
				<div
					v-for="(item, index) in historyRecord"
					:key="index"
					:ref="
						(el) => {
							ref_messages_nodes[item.id] = el;
						}
					"
				>
					<div class="flex_center" style="margin-top: 20px" v-if="item.type == 6">
						<div class="chart_line"></div>
						<div class="chart_name">以上是历史消息</div>
						<div class="chart_line"></div>
					</div>
					<div
						v-else
						class="chart_item"
						:style="{ flexDirection: item.type == 4 ? 'row' : 'row-reverse' }"
					>
						<div class="chart_head" v-if="item.nickname">
							<img
								style="width: 40px; height: 40px"
								src="../assets/user_icon.png"
								v-if="item.type == 4"
							/>
							<img
								style="width: 40px; height: 40px"
								src="../assets/head.png"
								v-else-if="item.type == 2"
							/>
							<img
								style="width: 40px; height: 40px"
								src="../assets/kefu_head.png"
								v-else-if="item.type == 3"
							/>
							<div v-else-if="item.type == 0 || item.type == 1" style="width: 40px"></div>
						</div>
						<div v-else-if="!item.nickname" style="width: 40px"></div>
						<div
							class="chart_content"
							:style="{
								marginLeft: item.type == 4 ? '20px' : '0px',
								marginRight: item.type == 4 ? '0px' : '20px',
							}"
						>
							<div
								class="chart_name"
								:style="{ textAlign: item.type == 4 ? 'left' : 'right', color: '#999999' }"
							>
								{{ item.type === 0 || item.type == 1 ? "" : item.nickname }}
							</div>

							<div
								class="flex_common"
								:style="{
									flexDirection: item.type == 4 ? 'row' : 'row-reverse',
									marginTop: '5px',
								}"
							>
								<div
									class="chart_item_content flex_common"
									:style="{
										padding: item.contentType == 2 ? '0' : '10px',
										backgroundColor:
											item.contentType == 2
												? 'transparent'
												: item.type == 4
												? '#FFFFFF'
												: item.type == 3 || item.type == 2
												? '#C194FF'
												: '#F5EEFF',
									}"
								>
									<div v-if="item.type == 0 || item.type == 1" class="chart_name">
										<div style="color: #a15bff">
											{{ item.nickname }}
										</div>
										<div
											v-for="(items, index) in item.contentMultiple"
											:key="index"
											style="margin-top: 10px"
										>
											<div>
												{{ items }}
											</div>
										</div>
									</div>
									<el-image
										class="chatImg"
										v-if="item.contentType == 2"
										:src="item.content"
										:preview-src-list="[item.content]"
										:zoom-rate="1.2"
										:max-scale="7"
										:min-scale="0.2"
										:hide-on-click-modal="true"
										fit="cover"
									/>
									<div
										v-else
										v-html="item.content"
										style="white-space: pre-wrap; word-wrap: break-word"
										class="chart_name"
									></div>
								</div>
								<div
									v-if="item.nickname && item.type != 0 && item.type != 1"
									class="chart_name"
									:style="{
										color: item.type != 4 ? '#C194FF' : '#999999',
										marginLeft: item.type != 4 ? '0' : '20px',
										marginRight: item.type != 4 ? '20px' : '0px',
									}"
								>
									{{ dayjs(item.createTime).format("YYYY-MM-DD HH:mm") }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 实时会话 -->
			<div
				class="chart_item"
				v-for="(item, index) in nowRecord"
				:key="index"
				:style="{ flexDirection: item.type == 4 ? 'row' : 'row-reverse' }"
			>
				<div class="chart_head">
					<img
						style="width: 40px; height: 40px"
						src="../assets/user_icon.png"
						v-if="item.type == 4"
					/>
					<img
						style="width: 40px; height: 40px"
						src="../assets/kefu_head.png"
						v-else-if="item.type == 3"
					/>
				</div>
				<div
					class="chart_content"
					:style="{
						marginLeft: item.type == 4 ? '20px' : '0px',
						marginRight: item.type == 4 ? '0px' : '20px',
					}"
				>
					<div
						class="chart_name"
						:style="{ textAlign: item.type == 4 ? 'left' : 'right', color: '#999999' }"
					>
						{{ item.type == 4 ? nickname : kefuName }}
					</div>

					<div
						class="flex_common"
						:style="{
							flexDirection: item.type == 4 ? 'row' : 'row-reverse',
							marginTop: '5px',
						}"
					>
						<div
							class="chart_item_content flex_common"
							:style="{
								padding: item.messageType == 2 ? '0' : '10px',
								backgroundColor:
									item.messageType == 2 ? 'transparent' : item.type == 4 ? '#FFFFFF' : '#C194FF',
							}"
						>
							<el-image
								class="chatImg"
								v-if="item.messageType == 2"
								:src="item.content"
								:preview-src-list="[item.content]"
								:zoom-rate="1.2"
								:max-scale="7"
								:min-scale="0.2"
								:hide-on-click-modal="true"
								fit="contain"
							/>
							<div v-else v-html="item.content" class="charText"></div>
						</div>
						<div
							class="chart_name"
							:style="{
								color: item.type != 4 ? '#C194FF' : '#999999',
								marginLeft: item.type != 4 ? '0' : '20px',
								marginRight: item.type != 4 ? '20px' : '0px',
							}"
						>
							{{ dayjs(item.time).format("YYYY-MM-DD HH:mm") }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="chart_control">
			<div
				ref="editor"
				class="chart_input"
				:contenteditable="true"
				@blur="saveSelection"
				@paste="handlePaste"
				@keydown.enter.exact.prevent="sendMessage"
				data-placeholder="输入消息，Enter 发送"
			></div>
			<div class="flex_between">
				<div @click="endSession" class="end_meeting flex_center">结束会话</div>
				<div style="display: flex">
					<el-upload
						ref="fileInput"
						:http-request="setimg"
						:headers="headers"
						:before-upload="beforePicUpload"
						:show-file-list="false"
						:auto-upload="true"
						method="post"
						accept="image/*"
						name="multipartFile"
						:data="{ flag: 'xw' }"
					>
						<div class="end_meeting flex_center" >上传图片</div>
					</el-upload>
					<div @click="sendMessage" class="send_message flex_center">发送</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted, onActivated, nextTick } from "vue";
import { get } from "../utils/request";
import { message } from "../utils/resetMessage";
import { uploadURL } from "../utils/global";
import axios from "axios";
import { ElLoading } from "element-plus";
import * as imageConversion from "image-conversion"; //处理图片
import dayjs from "dayjs";
const text = ref("");
const emit = defineEmits();
const props = defineProps(["nickname"]);
const kefuName = ref(sessionStorage.username);
const messageBox = ref(null);
const page = ref(1);
const nowRecord = ref([]);
const historyRecord = ref([]);
const ref_messages_nodes = ref({});
const hasNext = ref(false);
let scrollListener = ref(null);
const editor = ref(null);
const headers = {
	Authorization: `Bearer ${sessionStorage.customer_token}`,
};
let loadingInstance = null;
let savedRange = null;
//结束会话
const endSession = () => {
	emit("endSession");
};

const copyText = (e) => {
	insertImage(e, "text");
};

const handlePaste = (e) => {
	const items = e.clipboardData?.items || [];

	// 1. 检测剪贴板里有没有图片
	const hasImage = Array.from(items).some((item) => item.type.indexOf("image") === 0);

	// 2. 如果只有图片，直接阻止，什么都不做
	if (hasImage) {
		e.preventDefault();
		// 可选：给用户一个提示
		// message.warning('暂不支持粘贴图片，请点击 📷 上传');
		return;
	}

	// 3. 没有图片：只取纯文本，去掉所有 HTML 格式
	const text = e.clipboardData.getData("text/plain");
	if (text) {
		e.preventDefault();
		document.execCommand("insertText", false, text);
	}
};
const sendMessage = async () => {
	const el = editor.value;
	if (!el) return;

	// 1. 收集阶段：按顺序提取出 [文本, 图片, 文本...]
	const payloads = [];
	let textBuffer = "";

	const flushText = () => {
		if (textBuffer.trim()) {
			payloads.push({ text: textBuffer.trim(), messageType: 1 });
			textBuffer = "";
		}
	};

	const walk = (node) => {
		if (node.nodeType === Node.TEXT_NODE) {
			textBuffer += node.textContent;
			return;
		}
		if (node.nodeName === "IMG") {
			flushText();
			payloads.push({ text: node.src, messageType: 2 });
			return;
		}
		if (node.nodeName === "BR") {
			textBuffer += "\n";
			return;
		}
		if (node.nodeName === "DIV" || node.nodeName === "P") {
			if (textBuffer && !textBuffer.endsWith("\n")) textBuffer += "\n";
			node.childNodes.forEach(walk);
			if (textBuffer && !textBuffer.endsWith("\n")) textBuffer += "\n";
			return;
		}
		if (node.childNodes && node.childNodes.length) {
			node.childNodes.forEach(walk);
		}
	};

	el.childNodes.forEach(walk);
	flushText();

	// 2. 校验阶段：统计文本字符数（不含图片）
	const textLength = payloads
		.filter((p) => p.messageType === 1)
		.reduce((sum, p) => sum + p.text.length, 0);

	if (textLength > 1000) {
		message.warning("字符数不能超过 1000 个");
		return;
	}

	// 3. 发送 + 记录阶段
	const time = new Date().toLocaleString();
	for (const p of payloads) {
		emit("updateData", p);
		nowRecord.value.push({
			type: 3,
			richText: 0,
			messageType: p.messageType,
			content: p.text,
			time,
		});
	}

	// 4. 清空 + 滚动
	el.innerHTML = "";
	await nextTick();
	if (messageBox.value) {
		messageBox.value.scrollTop = messageBox.value.scrollHeight;
	}
};
const insertImage = (url, type) => {
	const el = editor.value;
	if (!el) return;

	// ✅ 如果是插入图片，先判断已插入数量（在 focus 之前判断也行，位置随意，只要在插入前即可）

	el.focus(); // 先让编辑器获得焦点

	// 恢复之前保存的光标位置
	const selection = window.getSelection();
	selection.removeAllRanges();
	if (savedRange) {
		selection.addRange(savedRange);
	} else {
		// 没有保存过，就放到末尾
		const range = document.createRange();
		range.selectNodeContents(el);
		range.collapse(false); // 折叠到末尾
		selection.addRange(range);
	}

	if (type == "img") {
		const img = document.createElement("img");
		img.src = url;
		img.className = "inline-img";
		// 插入到当前光标
		const range = selection.getRangeAt(0);
		range.deleteContents();
		range.insertNode(img);
		// 光标移到图片后面
		range.setStartAfter(img);
		range.setEndAfter(img);
		selection.removeAllRanges();
		selection.addRange(range);
	} else {
		const range = selection.getRangeAt(0);
		range.deleteContents();
		const textNode = document.createTextNode(url);
		range.insertNode(textNode);
		// 光标移到插入文字后面
		range.setStartAfter(textNode);
		range.setEndAfter(textNode);
		selection.removeAllRanges();
		selection.addRange(range);
	}

	// 插入后清掉保存的 Range，避免下次复用
	savedRange = null;
};
// 编辑器失焦 / 点击上传按钮时调用
const saveSelection = () => {
	const selection = window.getSelection();
	if (selection.rangeCount > 0) {
		const range = selection.getRangeAt(0);
		// 确保选区在编辑器内部
		if (editor.value?.contains(range.commonAncestorContainer)) {
			savedRange = range.cloneRange(); // 克隆一份保存
		}
	}
};
//接受用户消息
const pushUserMessage = async (data) => {
	nowRecord.value.push({
		time: new Date().toLocaleString(),
		type: 4,
		content: data.msg,
		messageType: data.messageType,
	});
	await nextTick();
	messageBox.value.scrollTop = messageBox.value.scrollHeight;
};
const getScrollHeight = (id, dialogue) => {
	setTimeout(() => {
		const box = messageBox.value;
		messageBox.value.scrollTop = messageBox.value.scrollHeight;
		if (box && scrollListener) {
			box.removeEventListener("scroll", scrollListener);
		}
		if (box) {
			scrollListener = () => {
				if (box.scrollTop === 0) {
					if (hasNext.value) {
						loadMore(id, dialogue);
					}
				}
			};

			// 监听滚动事件
			box.addEventListener("scroll", scrollListener);
		}
	}, 0);
};
//获取历史记录
const getHistoryRecord = (uId, dialogueId) => {
	page.value = 1;
	hasNext.value = false;
	nowRecord.value = [];
	get(
		`/api-cms/reception/dialogue?page=${page.value}&size=10&userId=${uId}&dialogueId=${dialogueId}`,
		{},
		false,
	)
		.then((res) => {
			if (res.code == 1) {
				if (page.value == 1) {
					if (res.result.historyIndex != -1) {
						res.result.list.splice(res.result.historyIndex - 1, 0, {
							type: 6,
						});
					}
					historyRecord.value = res.result.list.reverse();

					hasNext.value = res.result.hasNext;
				}
				getScrollHeight(uId, dialogueId);
			}
		})
		.catch((err) => {});
};

//加载更多
const loadMore = (uId, dialogueId) => {
	page.value++;
	get(
		`/api-cms/reception/dialogue?page=${page.value}&size=10&userId=${uId}&dialogueId=${dialogueId}`,
		{},
		false,
	)
		.then((res) => {
			if (res.code == 1) {
				hasNext.value = res.result.hasNext;
				if (res.result.historyIndex != -1) {
					res.result.list.splice(res.result.historyIndex - 1, 0, {
						type: 6,
					});
				}
				historyRecord.value = [...res.result.list.reverse(), ...historyRecord.value];

				setTimeout(() => {
					const length = res.result.list.length;
					let listIndex = length > 0 ? length - 1 : length;
					let top_id = historyRecord.value[listIndex].id;
					ref_messages_nodes.value[top_id].scrollIntoView();
				}, 0);
			}
		})
		.catch((err) => {});
};

// 上传图片之前的回调函数
const beforePicUpload = (file) => {
	const isImage = file.type.startsWith("image/");
	if (!isImage) {
		message.error("图片格式错误");
		return false;
	}
	const el = editor.value;
	const existingImgs = el.querySelectorAll("img").length;
	if (existingImgs == 5) {
		message.warning("最多只能插入 5 张图片");
		return false; // 直接中断，不插入
	}
	const isWidth = new Promise((resolve, reject) => {
		let _URL = window.URL || window.webkitURL;
		let img = new Image();
		img.onload = function () {
			if (img.width > 3000 || file.size > 1024 * 1024 * 2) {
				imageConversion
					.compress(file, {
						quality: 0.3,
						width: 3000,
					})
					.then((res) => {
						resolve(res);
					});
			} else {
				resolve(file);
			}
		};
		img.src = _URL.createObjectURL(file);
	});
	return isImage && isWidth;
};
const setimg = (files) => {
	const file = files.file;
	const axiosInstance = axios.create({
		baseURL: uploadURL, // 请求api
		timeout: 20000,
		headers: {
			Authorization: "Bearer " + sessionStorage.customer_token,
		},
	});
	let formData = new FormData();
	formData.append("multipartFile", file);
	formData.append("flag", "xw");
	if (!loadingInstance) {
		loadingInstance = ElLoading.service({
			lock: true,
			text: "图片上传中...",
			background: "rgba(0, 0, 0, 0.7)",
		});
	}
	axiosInstance
		.post("", formData, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		})
		.then((res) => {
			loadingInstance.close();
			loadingInstance = null;
			if (res.data.code == 1) {
				insertImage(res.data.result.img, "img");
				message.success("上传成功");
			} else {
				message.error("上传失败");
			}
		})
		.catch((error) => {
			loadingInstance.close();
			loadingInstance = null;
			message.error("上传失败");
		});
};

onActivated(() => {
	messageBox.value.scrollTop = messageBox.value.scrollHeight;
});

onMounted(() => {
	//监听滚动
	// observer.value = new MutationObserver(() => {
	// 	if (messageBox.value) {
	// 		messageBox.value.scrollTop = messageBox.value.scrollHeight;
	// 	}
	// });
	// observer.value.observe(messageBox.value, {
	// 	childList: true,
	// 	subtree: true,
	// });
});

defineExpose({ pushUserMessage, messageBox, copyText, getHistoryRecord, getScrollHeight });
</script>

<style scoped lang="less">
.chart_window {
	width: 100%;
	background-color: #f7f7f7;
	height: calc(100vh - 100px);
	position: relative;
	display: flex;
	flex-direction: column;
	border-left: 1px solid #dedede;
	.chart_container {
		padding: 20px;
		box-sizing: border-box;
		width: 100%;
		// height: calc(100vh - 145px - 95px);
		flex: 1;
		overflow: auto;
		.chart_item {
			display: flex;
			// flex-direction: column;
			margin-top: 20px;
		}
		.chart_content {
			width: 100%;
		}
		.chart_item_content {
			border-radius: 5px;
			max-width: 70%;
			word-break: break-all;
		}
	}
	.chart_control {
		width: 100%;
		// position: absolute;
		// bottom: 0px;
		// min-height: 195px;
		background: #ffffff;
		border-top: 1px solid #dedede;
		padding-bottom: 20px;
		.chart_input {
			width: 100%;
			max-height: 300px;
			box-sizing: border-box;
			border-width: 0px;
			border-bottom-left-radius: 10px;
			border-bottom-right-radius: 10px;
			outline: none;
			padding: 20px;
			resize: none;
			color: #000000;
			font-size: 14px;
			overflow-y: auto;
			margin-bottom: 15px;
		}
		.end_meeting {
			width: 88px;
			height: 32px;
			background: #ffffff;
			border-radius: 4px;
			border: 1px solid #a15bff;
			font-size: 14px;
			color: #a15bff;
			line-height: 22px;
			margin-left: 20px;
			cursor: pointer;
			margin-right: 20px;
		}
		.send_message {
			width: 60px;
			height: 32px;
			background: #a15bff;
			border-radius: 4px;
			font-size: 14px;
			color: #ffffff;
			line-height: 22px;
			margin-right: 20px;
			cursor: pointer;
		}
	}
}
.chart_name {
	font-weight: 400;
	font-size: 14px;
	color: #333333;
}
.chart_line {
	width: 120px;
	height: 1px;
	background-color: #333333;
}
.load_more {
	width: 100%;
	height: 20px;
}
.chart_input :deep(.inline-img) {
	max-width: 150px;
	max-height: 150px;
	object-fit: contain;
}
.charText {
	white-space: pre-wrap;
	word-wrap: break-word;
	font-size: 14px;
	color: #333333;
}
.chatImg {
	max-width: 150px;
	max-height: 150px;
	border-radius: 4px;
}
</style>
